

















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ChartOptionsMenu from './ChartOptionsMenu.vue'

@Component({
    components: {
        ChartOptionsMenu
    }
})
export default class RangeBarChart extends Vue {
    @Prop({ required: true }) loading!: boolean;
    @Prop({ required: true }) title!: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop({ required: true }) data!: any;

    localLoading = true;
    noData = false;
    categorieLabels: string[] = [];

    chartOptions = {
        theme: {
            mode: 'dark'
        },
        chart: {
            background: '#212121'
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true
            }
        },
        dataLabels: {
            enabled: true,
            offsetX: 8
        },
        tooltip: {
            shared: true,
            intersect: false
        },
        xaxis: {
            categories: [
                'Opratel',
                'Renxo',
                'Digital Virgo',
                'Chocolate',
                'Digevo',
                'Celcom'
            ]
        },
        legend: {
            horizontalAlign: 'left',
            fontSize: '14px',
            offsetX: 2,
            itemMargin: {
                horizontal: 10,
                vertical: 0
            }
        },
        colors: ['#0D47A1', '#B71C1C', '#00E396', '#FEB019', '#775DD0']
    };

    series = [
        {
            name: 'Octubre 2021',
            data: [44, 55, 41, 64, 22, 43, 21]
        },
        {
            name: 'Noviembre 2021',
            data: [53, 32, 33, 52, 13, 44, 32]
        }
    ];

    @Watch('loading')
    ondialogPropChange () {
        this.localLoading = this.loading
    }

    changeChart (chart: string) {
        this.$emit('change-chart', { index: this.data.widgetId, chart })
    }

    getReportData () {
        this.localLoading = true
        this.$store.dispatch('viewReport', {
            reportId: this.data.reportId.reportId,
            reportFilters: []
        })
            .then((resp) => {
                if (resp?.status === 200) {
                    // this.formatData(resp.data)
                }
                this.localLoading = false
            })
            .catch((error) => {
                this.localLoading = false
                console.log(error)
            })
    }

    mounted () {
        this.getReportData()
        setInterval(this.getReportData, 300000)
    }
}
